import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTheme } from '@mui/material/styles'
import { ConnectWidget } from '@mxenabled/web-widget-sdk'

import ConnectStatus from './ConnectStatus'
import { Drawer, useAccountStore, useGlobalCopyStore } from '../../common'
import { MemberConnectionStatus } from '../constants/Connect'
import { CONNECT_WIDGET_ID } from '../constants/Connect'
import { useConnectStore } from '../context/hooks'

interface ConnectDrawerProps {
  loadWidgetProps?: object
  onClose: () => void
  showConnectWidget: boolean
  title: string
}

const ConnectDrawer: React.FC<ConnectDrawerProps> = ({
  loadWidgetProps,
  onClose,
  showConnectWidget,
  title,
}) => {
  let connectWidget: ConnectWidget

  const { refreshAccounts } = useAccountStore()
  const { loadWidget } = useConnectStore()
  const { connect: connectCopy } = useGlobalCopyStore()
  const [isLoading, setIsLoading] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)
  const {
    palette: { mode },
  } = useTheme()

  React.useEffect(() => {
    if (showConnectWidget) {
      setIsLoading(true)
      loadWidget({ mode: mode, ...loadWidgetProps }).then((res) => {
        connectWidget = new ConnectWidget({
          container: `#${CONNECT_WIDGET_ID}`,
          style: {
            border: 'none',
            height: 'calc(100% - 62px)',
            maxWidth: '450px',
            position: 'absolute',
            width: '100%',
          },
          url: res.url,
          onSsoUrlLoadError: () => {
            setIsLoading(false)
            setHasError(true)
          },
          onLoad: () => {
            setIsLoading(false)
            setHasError(false)
          },
        })
      })
    } else {
      setIsLoading(false)
      setHasError(false)
    }

    return () => {
      connectWidget?.unmount()
    }
  }, [showConnectWidget])

  return (
    <Drawer
      ariaLabelClose={connectCopy.close_manage_connection_aria}
      isOpen={showConnectWidget}
      onClose={() => {
        onClose()
        refreshAccounts()
      }}
      title={title}
    >
      <div id={CONNECT_WIDGET_ID}>
        {hasError && <ConnectStatus status={MemberConnectionStatus.Error} />}
        {isLoading && <ConnectStatus status={MemberConnectionStatus.Loading} />}
      </div>
    </Drawer>
  )
}

export default observer(ConnectDrawer)
